/* ------------------------------------------------------------------
   KONVERTERINGS-RETTELSER  (22-10, Claude)
   1) Kurv-knap paa produktbilledet (direkte i kurv eller vindue med valg af stoerrelse)
   2) Produkttekst: kort intro med "Laes mere" + fakta (stoerrelse, materiale, pleje)
   3) Kollektioner: flere produkter hentes automatisk i bunden af siden
   Fejler noget, goer scriptet ingenting, og siden virker som foer.
   ------------------------------------------------------------------ */
(function () {
  'use strict';

  var isDanish = (document.documentElement.lang || 'da').toLowerCase().indexOf('da') === 0;

  /* 1) Kurv-knap paa produktbilledet ---------------------------------------
     - [data-md-quick-add]: produkt uden varianter, laegges direkte i kurven
     - [data-md-quick-choose]: produkt med flere varianter, aabner et vindue
       hvor kunden vaelger stoerrelse/variant
     Kurven aabnes via temaets eget "product:added"-event. */
  var texts = isDanish ? {
    choose: 'Vælg størrelse',
    chooseVariant: 'Vælg variant',
    soldOut: 'Udsolgt',
    added: 'Tilføjet',
    error: 'Det lykkedes ikke. Prøv igen.',
    close: 'Luk'
  } : {
    choose: 'Choose size',
    chooseVariant: 'Choose variant',
    soldOut: 'Sold out',
    added: 'Added',
    error: 'Something went wrong. Please try again.',
    close: 'Close'
  };

  var routes = window.routes || {};
  var rootUrl = routes.rootUrlWithoutSlash || '';
  var cartAddUrl = (routes.cartAddUrl || '/cart/add') + '.js';

  function formatMoney(cents) {
    var themeSettings = window.theme || {};
    var format = (themeSettings.currencyCodeEnabled ? themeSettings.moneyWithCurrencyFormat : themeSettings.moneyFormat) || '{{amount_with_comma_separator}} kr';
    format = String(format).replace(/<[^>]*>/g, '');
    var value = (cents || 0) / 100;

    function number(amount, decimals, thousands, decimal) {
      var parts = amount.toFixed(decimals).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return parts.join(decimal);
    }

    var match = format.match(/\{\{\s*(\w+)\s*\}\}/);
    var key = match ? match[1] : 'amount_with_comma_separator';
    var amount;
    switch (key) {
      case 'amount': amount = number(value, 2, ',', '.'); break;
      case 'amount_no_decimals': amount = number(value, 0, ',', '.'); break;
      case 'amount_no_decimals_with_comma_separator': amount = number(value, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': amount = number(value, 2, "'", '.'); break;
      default: amount = number(value, 2, '.', ',');
    }
    return format.replace(/\{\{\s*\w+\s*\}\}/, amount);
  }

  function addToCart(variantId) {
    return fetch(cartAddUrl, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    }).then(function (response) {
      if (!response.ok) { throw new Error('add failed'); }
      /* Temaets kurv lytter paa dette event og aabner kurven */
      document.dispatchEvent(new CustomEvent('product:added', {
        bubbles: true,
        detail: { variant: { id: variantId }, quantity: 1 }
      }));
    });
  }

  /* Produkt uden varianter: direkte i kurven */
  document.addEventListener('click', function (event) {
    var button = event.target.closest ? event.target.closest('[data-md-quick-add]') : null;
    if (!button) { return; }

    event.preventDefault();
    event.stopPropagation();
    if (button.disabled) { return; }

    var variantId = parseInt(button.getAttribute('data-md-quick-add'), 10);
    if (!variantId) { return; }

    button.disabled = true;
    button.classList.add('is-loading');

    addToCart(variantId).then(function () {
      button.disabled = false;
      button.classList.remove('is-loading');
    }).catch(function () {
      button.disabled = false;
      button.classList.remove('is-loading');
      var url = button.getAttribute('data-md-url');
      if (url) { window.location.href = url; }
    });
  });

  /* Produkt med flere varianter: vindue med valg */
  var productCache = {};
  var chooser = null;

  function loadProduct(handle) {
    if (productCache[handle]) { return Promise.resolve(productCache[handle]); }
    return fetch(rootUrl + '/products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin' })
      .then(function (response) {
        if (!response.ok) { throw new Error('product failed'); }
        return response.json();
      })
      .then(function (product) {
        productCache[handle] = product;
        return product;
      });
  }

  function useSheet() {
    return window.matchMedia('(max-width: 640px), (hover: none)').matches;
  }

  function closeChooser(returnFocus) {
    if (!chooser) { return; }
    var current = chooser;
    chooser = null;

    if (current.panel.parentNode) { current.panel.parentNode.removeChild(current.panel); }
    if (current.backdrop && current.backdrop.parentNode) { current.backdrop.parentNode.removeChild(current.backdrop); }
    if (current.box) { current.box.classList.remove('is-choosing'); }
    document.documentElement.classList.remove('md-chooser-open');
    current.button.setAttribute('aria-expanded', 'false');
    if (returnFocus) { current.button.focus(); }
  }

  function chooserTitle(product) {
    var options = product.options || [];
    if (options.length === 1) {
      var name = String(typeof options[0] === 'string' ? options[0] : (options[0].name || '')).toLowerCase().trim();
      if (name === 'størrelse' || name === 'size' || name === 'str.' || name === 'str') { return texts.choose; }
    }
    return texts.chooseVariant;
  }

  function openChooser(button, product) {
    var sheet = useSheet();
    var box = button.closest('.MdImageBox');

    var panel = document.createElement('div');
    panel.className = 'MdChooser' + (sheet ? ' MdChooser--sheet' : '');
    panel.setAttribute('role', 'dialog');
    panel.setAttribute('aria-label', chooserTitle(product) + ': ' + product.title);
    if (sheet) { panel.setAttribute('aria-modal', 'true'); }

    var header = document.createElement('div');
    header.className = 'MdChooser__Header';
    var heading = document.createElement('span');
    heading.className = 'MdChooser__Title';
    heading.textContent = sheet ? product.title : chooserTitle(product);
    header.appendChild(heading);

    var close = document.createElement('button');
    close.type = 'button';
    close.className = 'MdChooser__Close';
    close.setAttribute('aria-label', texts.close);
    close.innerHTML = '<svg viewBox="0 0 16 16" aria-hidden="true" focusable="false"><path d="M3 3l10 10M13 3L3 13" stroke="currentColor" stroke-width="1.5" fill="none" stroke-linecap="round"/></svg>';
    close.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopPropagation();
      closeChooser(true);
    });
    header.appendChild(close);
    panel.appendChild(header);

    if (sheet) {
      var sub = document.createElement('p');
      sub.className = 'MdChooser__Sub';
      sub.textContent = chooserTitle(product);
      panel.appendChild(sub);
    }

    var list = document.createElement('ul');
    list.className = 'MdChooser__List';
    var message = document.createElement('p');
    message.className = 'MdChooser__Message';
    message.setAttribute('aria-live', 'polite');

    (product.variants || []).forEach(function (variant) {
      var item = document.createElement('li');
      var option = document.createElement('button');
      option.type = 'button';
      option.className = 'MdChooser__Option';

      var name = document.createElement('span');
      name.className = 'MdChooser__Name';
      name.textContent = variant.public_title || variant.title;
      option.appendChild(name);

      var price = document.createElement('span');
      price.className = 'MdChooser__Price';
      price.textContent = variant.available ? formatMoney(variant.price) : texts.soldOut;
      option.appendChild(price);

      if (!variant.available) {
        option.disabled = true;
      } else {
        option.addEventListener('click', function (event) {
          event.preventDefault();
          event.stopPropagation();
          if (panel.classList.contains('is-busy')) { return; }
          panel.classList.add('is-busy');
          option.classList.add('is-loading');
          message.textContent = '';

          addToCart(variant.id).then(function () {
            option.classList.remove('is-loading');
            option.classList.add('is-added');
            price.textContent = texts.added + ' ✓';
            setTimeout(function () { closeChooser(false); }, 450);
          }).catch(function () {
            panel.classList.remove('is-busy');
            option.classList.remove('is-loading');
            message.textContent = texts.error;
          });
        });
      }

      item.appendChild(option);
      list.appendChild(item);
    });

    panel.appendChild(list);
    panel.appendChild(message);

    var backdrop = null;
    if (sheet || !box) {
      backdrop = document.createElement('div');
      backdrop.className = 'MdChooserBackdrop';
      backdrop.addEventListener('click', function () { closeChooser(true); });
      document.body.appendChild(backdrop);
      panel.classList.add('MdChooser--sheet');
      document.body.appendChild(panel);
      document.documentElement.classList.add('md-chooser-open');
    } else {
      box.appendChild(panel);
      box.classList.add('is-choosing');
    }

    button.setAttribute('aria-expanded', 'true');
    chooser = { panel: panel, backdrop: backdrop, box: box, button: button };

    var first = panel.querySelector('.MdChooser__Option:not([disabled])') || close;
    first.focus({ preventScroll: true });
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest ? event.target.closest('[data-md-quick-choose]') : null;

    if (!button) {
      /* Klik uden for vinduet lukker det */
      if (chooser && !chooser.panel.contains(event.target)) { closeChooser(false); }
      return;
    }

    event.preventDefault();
    event.stopPropagation();

    if (chooser && chooser.button === button) {
      closeChooser(true);
      return;
    }
    closeChooser(false);

    if (button.classList.contains('is-loading')) { return; }
    button.classList.add('is-loading');

    loadProduct(button.getAttribute('data-md-quick-choose')).then(function (product) {
      button.classList.remove('is-loading');
      openChooser(button, product);
    }).catch(function () {
      button.classList.remove('is-loading');
      var url = button.getAttribute('data-md-url');
      if (url) { window.location.href = url; }
    });
  });

  document.addEventListener('keydown', function (event) {
    if (chooser && (event.key === 'Escape' || event.key === 'Esc')) {
      closeChooser(true);
    }
  });

  /* 2) Produkttekst: intro + fakta --------------------------------------------- */
  function enhanceDescription() {
    var rte = document.querySelector('.ProductMeta__Description .Rte');
    if (!rte || rte.getAttribute('data-md-enhanced')) { return; }

    /* Roer ikke tekster med links, billeder, tabeller eller lister */
    if (rte.querySelector('a, img, table, iframe, video, ul, ol')) { return; }

    var text = (rte.innerText || '').replace(/\r/g, '').replace(/ /g, ' ');
    var start = text.search(/(^|\n)\s*Størrelse\s*:/i);
    if (start <= 0) { return; }

    var story = text.slice(0, start).trim();
    var lines = text.slice(start).split(/\n+/).map(function (l) { return l.trim(); }).filter(Boolean);

    /* Alle fakta-linjer skal ligne "Overskrift: vaerdi" */
    var facts = [];
    for (var i = 0; i < lines.length; i++) {
      var match = lines[i].match(/^([^:]{2,30}):\s*(.+)$/);
      if (!match) { return; }
      facts.push({ label: match[1].trim(), value: match[2].trim() });
    }
    if (!facts.length || story.length < 40) { return; }

    var wrapper = document.createElement('div');

    var storyEl = document.createElement('div');
    storyEl.className = 'MdStory';
    story.split(/\n+/).forEach(function (paragraph) {
      paragraph = paragraph.trim();
      if (!paragraph) { return; }
      var p = document.createElement('p');
      p.textContent = paragraph;
      storyEl.appendChild(p);
    });
    wrapper.appendChild(storyEl);

    var toggle = document.createElement('button');
    toggle.type = 'button';
    toggle.className = 'MdStory__Toggle';
    toggle.textContent = isDanish ? 'Læs mere' : 'Read more';
    toggle.setAttribute('aria-expanded', 'false');
    wrapper.appendChild(toggle);

    var list = document.createElement('ul');
    list.className = 'MdFacts';
    facts.forEach(function (fact) {
      var li = document.createElement('li');
      var label = document.createElement('strong');
      label.textContent = fact.label + ':';
      li.appendChild(label);
      li.appendChild(document.createTextNode(' ' + fact.value));
      list.appendChild(li);
    });
    wrapper.appendChild(list);

    rte.innerHTML = '';
    rte.appendChild(wrapper);
    rte.setAttribute('data-md-enhanced', '1');

    /* Klap kun teksten sammen, hvis den er lang */
    storyEl.classList.add('is-collapsed');
    if (storyEl.scrollHeight <= storyEl.clientHeight + 4) {
      storyEl.classList.remove('is-collapsed');
      toggle.hidden = true;
    }

    toggle.addEventListener('click', function () {
      var collapsed = storyEl.classList.toggle('is-collapsed');
      toggle.textContent = collapsed ? (isDanish ? 'Læs mere' : 'Read more') : (isDanish ? 'Vis mindre' : 'Show less');
      toggle.setAttribute('aria-expanded', collapsed ? 'false' : 'true');
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', enhanceDescription);
  } else {
    enhanceDescription();
  }

  /* 3) Kollektioner: hent automatisk flere produkter, naar man naermer sig
     bunden. Bruger den eksisterende "Vis flere"-knap (snippets/pagination),
     som bliver staaende som reserve og viser "Henter ..." imens. */
  var autoLoadQueued = false;

  function autoLoadCheck() {
    autoLoadQueued = false;
    var root = document.querySelector('[data-load-more-root][data-load-more-bound]');
    if (!root) { return; }
    var button = root.querySelector('[data-load-more-button]');
    if (!button || !button.getAttribute('href') || button.classList.contains('is-loading') || !button.offsetParent) { return; }

    if (button.getBoundingClientRect().top < window.innerHeight + 600) {
      button.click();
      waitForLoad(button, 0);
    }
  }

  function waitForLoad(button, tries) {
    if (tries > 40) { return; }
    setTimeout(function () {
      if (button.isConnected && button.classList.contains('is-loading')) {
        waitForLoad(button, tries + 1);
        return;
      }
      queueAutoLoad();
    }, 400);
  }

  function queueAutoLoad() {
    if (autoLoadQueued) { return; }
    autoLoadQueued = true;
    window.requestAnimationFrame(autoLoadCheck);
  }

  window.addEventListener('scroll', queueAutoLoad, { passive: true });
  window.addEventListener('resize', queueAutoLoad);
  if (document.readyState === 'complete') {
    queueAutoLoad();
  } else {
    window.addEventListener('load', queueAutoLoad);
  }
})();
